import { required } from '@jfs/ui-new'
import { Dropdown } from '../../components/Dropdown'
import { WrapperText } from '../../components/WrapperText'

const formData = (packageNamesData: any, instrumentTypes: any, onSubmit: (values: any) => void, message: string) => [
  {
    formItems: [
      {
        fieldName: 'packageName',
        ComponentName: Dropdown,
        title: 'Package Name',
        validationSchema: required,
        data: packageNamesData,
      },
      {
        fieldName: 'instrument',
        ComponentName: Dropdown,
        data: instrumentTypes,
        title: 'Instrument',
        validationSchema: required,
        isMultiSelect: true,
      },
      {
        fieldName: 'message',
        ComponentName: WrapperText,
        title: message,
        color: 'ERROR',
        hide: message === '',
      },
    ],
    onSubmit: async (values: any) => {
      onSubmit(values)
      return 'end'
    },
    actionTitle: 'Submit',
  },
]

export { formData }
